import { forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { BaseMUIComponentProps } from '../types/Types';

/**
 * Props du composant DropdownElement.
 */
export interface DropdownItemsSelectorProps extends BaseMUIComponentProps {
  initialSelectedItem?: number | null;
  onSelectItem: (valueId: number | null) => void;
  values: Array<{ id: number; name: string }>;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}

/**
 * DropdownStringSelector
 *
 * dropdown component based on MUI's `Autocomplete` for selecting a string value from a predefined list of options.
 * @param initialSelectedItem- The initial selected value of the dropdown.
 * @param onSelectItem - Callback function triggered when a value is selected or cleared.
 * @param values - Array of string options available in the dropdown.
 * @param open: Optional external control for the dropdown’s open/closed state.
 * @param errors - Error status object used to display validation messages after form submission.
 *
 */

export function DropdownItemsSelector({
  initialSelectedItem = null,
  onSelectItem,
  values,
  open,
  setOpen,
  ...props
}: DropdownItemsSelectorProps) {
  return (
    <Autocomplete
      disablePortal
      options={values}
      getOptionLabel={(option) => option.name}
      onChange={(_, value) => {
        onSelectItem(value ? value.id : null);
      }}
      className={props.className}
      disabled={props.disabled}
      open={open}
      onOpen={setOpen ? () => setOpen(true) : undefined}
      onClose={setOpen ? () => setOpen(false) : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          error={
            props.errors &&
            props.errors.tag === 'Submited' &&
            props.errors.errors.length !== 0
          }
          helperText={
            props.errors && props.errors.tag === 'Submited'
              ? props.errors.errors.join(', ')
              : ''
          }
          required={props.required}
        />
      )}
    />
  );
}